import React, { Fragment, useState, useEffect, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { MdOutlineListAlt, MdAddCircle } from "react-icons/md";
import Swal from 'sweetalert2';

import { CRMContext } from '../context/CRMContext';
import clienteAxios from '../../config/axios';

function FormNuevoCotizacionItem() {

    const [ item, guardarItem ] = useState({
        nombre: '',
        descripcion: '',
        claveUnica: '',
        valorActual: '',
        fechaValor: '',
        activo: true
    });
    let entre = 0;

    const [auth, guardarAuth] = useContext(CRMContext);

    let navigate = useNavigate();

    const actualizarState = e => {
        const { name, type, checked, value } = e.target;

        guardarItem({
            ...item,
            [name]: type === 'checkbox' ? checked : value
        });
    }

    const validarForm = () => {
        const { nombre, claveUnica, valorActual } = item;

        if( nombre.length > 0 && claveUnica.length > 0 && String(valorActual).length > 0 && Number(valorActual) >= 0 ){
            return true;
        }

        return false;
    }

    const agregarItem = async (e) => {
        e.preventDefault();

        if( entre > 0) {
            return;
        }
        
        entre = 1;
        
        try {
            const payload = {
                nombre: item.nombre,
                descripcion: item.descripcion,
                claveUnica: item.claveUnica,
                valorActual: parseInt(item.valorActual, 10),
                fechaValor: item.fechaValor || null,
                activo: item.activo
            };

            const res = await clienteAxios.post('/cotizacion/items', payload,{
                headers: {
                    Authorization: `Bearer ${auth.token}`
                }
            });

            Swal.fire({
                title: 'Se agregó correctamente el ítem de cotización',
                text: res.data.msg,
                type: 'success',
                timer: 3500
            });
                
            navigate('/cotizacion-items', {replace: true});
        } catch (error) {
            console.log(error)
            entre = 0;
            Swal.fire({
                type: 'error',
                title: 'Hubo un error',
                text: error.response?.data?.msg || 'No se pudo crear el ítem',
                timer: 1500
            });            
        }
        
    }

    useEffect(() => {
        if(!(auth.auth && (localStorage.getItem('token') === auth.token))){  
            navigate('/login', {replace: true});
        } else if (auth.tipo !== 1) { 
            navigate('/login', {replace: true});
        }
    },[]);

    return (
        <Fragment>
            <div className="card contenedor">
                <div className="card-header">
                    <MdAddCircle size={50} color={"#333333"}/>
                    <MdOutlineListAlt size={50} color={"#333333"}/>
                    <h1>Crear Nuevo Item de Cotización</h1>
                </div>
                <div className="card-body">

                    <div className='top-left'>
                        <Link to={'/cotizacion-items'} className="btn-new btn-return"><IoArrowBackCircleOutline size={25}/> Regresar</Link>
                    </div>

                    <h2 className='card-body-subtitle'> Llene todos los campos según corresponda: </h2>

                    <form onSubmit={agregarItem}>
                        
                        <div className='campo'>
                            <label htmlFor="nombre">Nombre<span className='campo__obligatorio'>*</span>:</label>
                            <input 
                                type="text" 
                                id='nombre'
                                name='nombre'
                                placeholder='Nombre del ítem'
                                maxLength={191}
                                onChange={actualizarState}
                                value={item.nombre}
                            />
                        </div>
                        
                        <div className='campo'>
                            <label htmlFor="descripcion">Descripción (opcional):</label>
                            <input 
                                type="text" 
                                id='descripcion'
                                name='descripcion'
                                placeholder='Descripción del ítem'
                                maxLength={191}
                                onChange={actualizarState}
                                value={item.descripcion}
                            />
                        </div>

                        <div className='campo'>
                            <label htmlFor="claveUnica">Clave Única<span className='campo__obligatorio'>*</span>:</label>
                            <input 
                                type="text" 
                                id='claveUnica'
                                name='claveUnica'
                                placeholder='Clave única del ítem'
                                maxLength={191}
                                onChange={actualizarState}
                                value={item.claveUnica}
                            />
                        </div>

                        <div className='campo'>
                            <label htmlFor="valorActual">Valor Actual<span className='campo__obligatorio'>*</span>:</label>
                            <input 
                                type="number" 
                                id='valorActual'
                                name='valorActual'
                                placeholder='Valor actual del ítem'
                                min="0"
                                onChange={actualizarState}
                                value={item.valorActual}
                            />
                        </div>

                        <div className='campo'>
                            <label htmlFor="fechaValor">Fecha Valor (opcional):</label>
                            <input 
                                type="date" 
                                id='fechaValor'
                                name='fechaValor'
                                onChange={actualizarState}
                                value={item.fechaValor}
                            />
                        </div>

                        <div className='campo'>
                            <label htmlFor="activo">Activo:</label>
                            <input 
                                type="checkbox" 
                                id='activo'
                                name='activo'
                                onChange={actualizarState}
                                checked={item.activo}
                            />
                        </div>

                        <div className="enviar">
                            <input 
                                type="submit" 
                                className={ validarForm() ? 'btn-new btn-success-new' : "btn-new"}
                                value="Crear Nuevo Item de Cotización"
                                disabled={!validarForm()}
                            />
                        </div>
                    </form>
                </div>
            </div>
        </Fragment>
    )
}

export default FormNuevoCotizacionItem;
